import { User } from './User';

export class TokenModel {
  public token: string;
  public resetPassword: boolean;
  public userTerms: boolean;
  public user: User;
}
